import { render, staticRenderFns } from "./BigCrunchButton.vue?vue&type=template&id=ff18554e&scoped=true&"
import script from "./BigCrunchButton.vue?vue&type=script&lang=js&"
export * from "./BigCrunchButton.vue?vue&type=script&lang=js&"
import style0 from "./BigCrunchButton.vue?vue&type=style&index=0&id=ff18554e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff18554e",
  null
  
)

export default component.exports